import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, OnDestroy {

  @Input() inputDelay: number;
  @Output() filteredValue: EventEmitter<string> = new EventEmitter<string>();
  keyUp = new Subject<string>();
  filterSubscription: Subscription;
  searchFilter = '';

  constructor() { }

  ngOnInit(): void {
    this.filterSubscription = this.keyUp.pipe(
      debounceTime(this.inputDelay),
      distinctUntilChanged(),
    ).subscribe(value => {
      this.filteredValue.emit(value);
    });
  }

  onFilter(){
    this.keyUp.next(this.searchFilter);
  }

  onEnter(){
    this.filteredValue.emit(this.searchFilter);
  }

  onClear(){
    this.searchFilter = '';
    this.filteredValue.emit(this.searchFilter);
  }

  ngOnDestroy() {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

}
